import { Box, display, minWidth, Stack } from "@mui/system";
import { useTheme } from "@mui/system";
import useStyles from "./styles";
import dayjs from "dayjs";
import {
  Alert,
  Avatar,
  Button,
  Chip,
  IconButton,
  InputAdornment,
  ListItemIcon,
  ListItemText,
  MenuItem,
  Paper,
  Snackbar,
  TextField,
  Tooltip,
  Menu,
  Autocomplete,
  Grid,
} from "@mui/material";
import {
  AccessTimeFilled,
  Add,
  Clear,
  Delete,
  Edit,
  FilterAltOutlined,
  LockReset,
  Pageview,
  Person,
  PersonAddAlt1Outlined,
  PersonOff,
  Search,
  Settings,
} from "@mui/icons-material";
import { useEffect, useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import api from "../../../../../services/api";
import ModalAddUserClient from "./ModalAddUserCliente";
import ModalEditUserCliente from "./ModalEditUserCliente";
import ModalEditSenha from "./ModalEditSenha";
import { useNavigate } from "react-router-dom";
import DatagridComponent from "../../../../../components/datagridComponent/index";
import FilterBar from "../../../../../components/topBarFilter";
import InternoModalConfirmacaoSaida from "../../../../../components/modalSaindoDaPagina";

export default function Clientes(params) {
  const {
    openFilter,
    setOpenFilter,
    buscarUsuario,
    setBuscarUsuario,
    setOpenModalAddUser,
    openModalAddUser,
    allClientes,
    setAllClientes,
    setSelectCliente,
    selectCliente,
  } = params;
  const [userCliente, setUserCliente] = useState([]);
  /*   const [buscarUsuario, setBuscarUsuario] = useState(""); */
  const [snackbar, setSnackbar] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedRow, setSelectedRow] = useState({});
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [openModalEditUser, setOpenModalEditUser] = useState(false);
  const [openModalEditSenha, setOpenModalEditSenha] = useState(false);
  const navigate = useNavigate();

  const [loadingDelete, setLoadingDelete] = useState(false);
  /*   const [openModalAddUser, setOpenModalAddUser] = useState(false); */
  const [loading, setLoading] = useState(false);
  const [createButton, setCreateButton] = useState(false);

  const [newUserCliente, setNewUserClient] = useState({
    login: "",
    email: "",
    senha: "",
    cliente: "",
  });
  const [userEdit, setUserEdit] = useState({
    id: "",
    nome: "",
    sobrenome: "",
    login: "",
    email: "",
    status: "",
    foto: "",
    cliente: {},
  });

  const theme = useTheme();
  const styles = useStyles(theme);
  const open = Boolean(anchorEl);
  const deleteBody =
    "O usuário será deletado permanentemente. Deseja deletar excluir o usuário?";
  const confirmDelete = "Excluir";

  const filteredRows = userCliente
    ?.filter((row, index) => {
      row.numero = index;

      return (
        row.login?.toLowerCase()?.includes(buscarUsuario?.toLowerCase()) ||
        row.nome?.toLowerCase()?.includes(buscarUsuario?.toLowerCase()) ||
        row.email?.toLowerCase()?.includes(buscarUsuario?.toLowerCase()) ||
        row.sobrenome?.toLowerCase()?.includes(buscarUsuario?.toLowerCase()) ||
        row?.cliente?.nome
          ?.toLowerCase()
          ?.includes(buscarUsuario?.toLowerCase())
      );
    })
    // Compara por id do cliente escolhido no filtro.
    ?.filter((usuario) =>
      selectCliente ? usuario?.cliente?.id === selectCliente : usuario,
    );

  useEffect(() => {
    getUserClient();
    getAllClientes();
  }, []);

  const getUserClient = async () => {
    setLoading(true);
    try {
      const response = await api.get("/interno/findUserCliente");

      setUserCliente(response?.data);
    } catch (error) {
      setSnackbar({
        children: "Error: Não foi possivel se conectar ao servidor",
        severity: "error",
      });
    } finally {
      setLoading(false);
    }
  };
  const getAllClientes = async () => {
    try {
      const response = await api.get("/interno/clientes");
      setAllClientes(response?.data);
    } catch (error) {
      setSnackbar({
        children: "Error: Não foi possivel buscar clientes",
        severity: "error",
      });
      console.error(error);
    } finally {
    }
  };

  const deleteUserClient = async (idUserCliente) => {
    setLoadingDelete(true);
    try {
      const response = await api.post("/interno/deleteUserCliente", {
        idUserCliente: idUserCliente,
      });
      setOpenDeleteModal(false);
      const userClientes = userCliente.filter(
        (userCliente) => userCliente?.id !== idUserCliente,
      );
      setUserCliente(userClientes);
      setSnackbar({
        children: "Usuário excluído com sucesso!",
        severity: "success",
      });
    } catch (error) {
      setSnackbar({
        children: "Error: Não foi possivel se conectar ao servidor",
        severity: "error",
      });
    } finally {
      setLoadingDelete(false);
    }
  };

  const createUserCliente = async () => {
    try {
      // O modal já resolve o id da permissão (as permissões são por cliente)
      const permissaoId = newUserCliente?.permissaoId || "";

      const response = await api.post("/interno/createUserCliente", {
        login: newUserCliente?.login,
        senha: newUserCliente?.senha,
        email: newUserCliente?.email,
        clienteId: newUserCliente?.cliente,
        permissaoId,
      });
      setOpenModalAddUser(false);

      setUserCliente((prev) => [
        ...prev,
        {
          ...response?.data,
          permissoes: {
            permissaoId,
            permissao: {
              id: permissaoId,
              codigoPermissao: newUserCliente?.permissao,
              color: newUserCliente?.permissaoColor,
            },
          },
        },
      ]);
      setNewUserClient({
        login: "",
        email: "",
        senha: "",
        cliente: "",
        permissao: "",
        permissaoId: "",
        permissaoColor: "",
      });
      setSnackbar({
        children: "Usuário criado com sucesso!",
        severity: "success",
      });
    } catch (error) {
      let menssegeErro = error?.response?.data.error;
      if (menssegeErro === "Email already exists!") {
        setSnackbar({
          children: "E-mail existente",
          severity: "error",
        });
      } else if (menssegeErro === "User already exists!") {
        setSnackbar({
          children: "Usuário existente",
          severity: "error",
        });
      } else {
        setSnackbar({
          children: "Error: Não foi possivel se conectar ao servidor",
          severity: "error",
        });
      }
    } finally {
      setCreateButton(false);
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  // Receber acesso ao perfil externo
  const handleMirrorMode = async () => {
    try {
      setLoading(true);
      // "Backup" das informações do usuário interno"

      // Requisição das informações do cliente
      const response = await api.post("/interno/generateToken/mirror", {
        clientId: selectedRow?.id,
      });

      // Define variáveis de ambiente necessárias para acessar o layout do cliente externo
      if (response?.data?.token) {
        // localStorage.setItem(
        //   "logInternoCliente",
        //   JSON.stringify({ ...response?.data?.logs })
        // );
        localStorage.setItem(
          "userCliente",
          JSON.stringify({ ...response?.data }),
        );
        localStorage.setItem(
          "perfilCliente",
          JSON.stringify({ ...response?.data?.perfil }),
        );
        navigate("/mirror/resumo");
      }

      setSnackbar({
        children: "Modo de visualizar como cliente carregado com sucesso!",
        severity: "success",
      });
    } catch (error) {
      localStorage.removeItem("manipulatePerfil");
      if (error?.response?.status === 404) {
        setSnackbar({
          children: "Error: Perfil não encontrado.",
          severity: "error",
        });
      } else {
        setSnackbar({
          children: "Error: Não foi possivel se conectar ao servidor",
          severity: "error",
        });
      }
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    {
      field: "avatar",
      headerName: "",
      maxWidth: 50,
      minWidth: 50,
      flex: 1,
      sortable: false,

      renderCell: (params) => {
        const foto = params?.row?.foto ? params?.row?.foto : "";
        return (
          <Box sx={styles.containerFotoUser}>
            <Avatar
              sx={styles.containerAvatar}
              alt={params.row.foto ? params.row.nome : ""}
              src={foto ? foto : "/"}
            />
          </Box>
        );
      },
    },
    {
      field: "login",
      headerName: "Login",
      minWidth: 70,

      flex: 1,
      cellClassName: "centered-cell",
    },
    {
      field: "nome",
      headerName: "Nome",
      minWidth: 70,
      cellClassName: "centered-cell",

      flex: 1,
      renderCell: (params) => {
        return `${params?.row?.nome || ""} ${params?.row?.sobrenome || ""}`;
      },
    },
    {
      field: "email",
      headerName: "E-mail",
      cellClassName: "centered-cell",
      minWidth: 160,
      flex: 1,
      valueGetter: (params) => {
        return `${params || ""}`;
      },
    },
    {
      field: "cliente",
      headerName: "Cliente",
      minWidth: 260,
      cellClassName: "centered-cell",

      flex: 1,
      valueGetter: (params) => {
        return params?.nome || "";
      },
    },
    {
      field: "permissoes",
      headerName: "Permissões",
      minWidth: 150,
      cellClassName: "centered-cell",

      flex: 1,
      valueGetter: (params) => {
        return params?.permissao?.codigoPermissao || "";
      },
      renderCell: (params) => {
        // As permissões do portal são por cliente, então cada linha traz a sua
        // permissão do backend em vez de buscar em uma lista global
        const perm = params?.row?.permissoes?.permissao;

        if (!perm?.codigoPermissao) {
          return (
            <Tooltip title="Sem permissão" placement="top">
              <Box sx={styles.conatinerChip}>
                <Chip
                  label={"SEM PERMISSÃO"}
                  size="small"
                  sx={{
                    ...styles.chipPermissoes,
                    backgroundColor: "chip.main.arquive",
                  }}
                />
              </Box>
            </Tooltip>
          );
        }

        return (
          <Tooltip title={perm?.codigoPermissao?.toUpperCase()}>
            <Box sx={styles.conatinerChip}>
              <Chip
                label={perm?.codigoPermissao?.toUpperCase()}
                size="small"
                sx={
                  perm?.codigoPermissao?.toUpperCase() === "ADM"
                    ? {
                        ...styles.chipPermissoes,
                        backgroundColor: "chip.main.waitingReview",
                      }
                    : {
                        ...styles.chipPermissoes,
                        backgroundColor:
                          perm?.color || theme.palette.colors.gray.medium,
                      }
                }
              />
            </Box>
          </Tooltip>
        );
      },
    },
    {
      field: "status",
      headerName: "Status",
      minWidth: 65,

      flex: 1,
      valueGetter: (params) => {
        return params;
      },
      renderCell: (params) => {
        return (
          <>
            {params?.row?.status === 1 && params?.row?.ultimoAcesso ? (
              <Box sx={styles.containerPrimeiroAcesso}>
                <Tooltip title="Perfil ativo">
                  <Person sx={styles.person} />
                </Tooltip>
              </Box>
            ) : !params?.row?.status ? (
              <Box sx={styles.containerPrimeiroAcesso}>
                <Tooltip title="Perfil desativado">
                  <PersonOff
                    sx={{ color: theme.palette.chip.colorText.critical }}
                  />
                </Tooltip>
              </Box>
            ) : params?.row?.status === 1 && !params?.row?.ultimoAcesso ? (
              <Box sx={styles.containerPrimeiroAcesso}>
                <Tooltip title="Aguardando primeiro login">
                  <Box>
                    <Person sx={styles.personOff} />
                    <AccessTimeFilled sx={styles.containerIconTime} />
                  </Box>
                </Tooltip>
              </Box>
            ) : (
              <></>
            )}
          </>
        );
      },
    },
    {
      field: "ultimoAcesso",
      headerName: "Último Acesso",
      cellClassName: "centered-cell",
      flex: 1,
      minWidth: 100,
      type: "dataTime",
      valueGetter: (params) => {
        return (params?.createAt && dayjs(params?.createAt).toDate()) || "";
      },
      renderCell: (params) => {
        return (
          params?.row?.ultimoAcesso?.createAt &&
          dayjs(params?.row?.ultimoAcesso?.createAt).format("DD/MM/YYYY HH:mm")
        );
      },
    },

    {
      field: "detalhes",
      headerName: "Detalhes",
      maxWidth: 80,
      minWidth: 80,
      flex: 1,
      sortable: false,

      renderCell: (params) => {
        return (
          <Tooltip title="Visualizar perfil">
            <IconButton
              onClick={(event) => {
                setAnchorEl(event.currentTarget);
                setSelectedRow(params.row);
              }}
              id="basic-button"
              disabled={
                JSON.parse(localStorage.getItem("user"))?.usuario?.id ===
                params.row.id
              }
            >
              <Settings
                mode="view"
                params={params}
                sx={{
                  color:
                    JSON.parse(localStorage.getItem("user"))?.usuario?.id ===
                    params.row.id
                      ? theme.palette.mode === "dark"
                        ? "chip.main.arquive"
                        : "disabled.main"
                      : theme.palette.mode === "dark"
                        ? "disabled.main"
                        : "chip.main.arquive",
                }}
              />
            </IconButton>
          </Tooltip>
        );
      },
    },
  ];

  const selectorComponentLeft = (
    <Box sx={styles.boxSearchFields}>
      <TextField
        variant="outlined"
        label="Buscar usuário"
        value={buscarUsuario}
        size="small"
        onChange={(event) => {
          setBuscarUsuario(event.target.value);
        }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Search />
            </InputAdornment>
          ),
          endAdornment: buscarUsuario ? (
            <InputAdornment position="end">
              <IconButton onClick={() => setBuscarUsuario("")} edge="end">
                <Clear />
              </IconButton>
            </InputAdornment>
          ) : null,
        }}
        sx={styles.searcField}
      />
      <Autocomplete
        size="small"
        disablePortal
        options={allClientes}
        getOptionLabel={(option) => option?.nome || ""}
        sx={styles.clientAutocomplete}
        onChange={(event, cliente) => {
          setSelectCliente(cliente?.id || "");
        }}
        renderInput={(params) => <TextField {...params} label="Cliente" />}
      />
    </Box>
  );

  const selectorComponentRight = (
    <Button
      startIcon={<Add sx={styles.containerAdd} />}
      onClick={() => setOpenModalAddUser(true)}
      sx={styles.buttonNewClient}
      variant="outlined"
    >
      Novo Usuário Cliente
    </Button>
  );

  /*   const [openFilter, setOpenFilter] = useState(false); */
  const actions = [
    {
      icon: <FilterAltOutlined />,
      name: "Filtro",
      onClick: () => setOpenFilter(true),
    },
    {
      icon: <PersonAddAlt1Outlined />,
      name: "Novo Usuário Cliente",
      onClick: () => setOpenModalAddUser(true),
    },
  ];
  return (
    <Box sx={styles.container}>
      {/**F I L T R O S */}
      {/* <FilterBar
        actions={actions}
        selectorComponentLeft={selectorComponentLeft}
        selectorComponentRight={selectorComponentRight}
        windowWidth={30000}
        openFilter={openFilter}
        setOpenFilter={setOpenFilter}
        type={0}
      /> */}
      <Paper
        sx={styles.paper}
        elevation={theme.palette.mode === "dark" ? 0 : 3}
      >
        <Grid container>
          <Grid item xs={12}>
            <DatagridComponent
              rows={filteredRows}
              columns={columns}
              sxDatagrid={{
                "& .MuiDataGrid-row": {
                  height: 40,
                },
                "& .centered-cell": {
                  display: "flex",
                  alignItems: "center",
                },
              }}
            />{" "}
          </Grid>
        </Grid>
      </Paper>

      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
        disableScrollLock={true}
      >
        <MenuItem
          onClick={() => {
            setAnchorEl(null);
            setOpenModalEditUser(true);
          }}
        >
          <ListItemIcon>
            <Edit />
          </ListItemIcon>
          <ListItemText>Editar</ListItemText>
        </MenuItem>
        <MenuItem
          onClick={() => {
            setAnchorEl(null);
            setOpenModalEditSenha(true);
          }}
        >
          <ListItemIcon>
            <LockReset />
          </ListItemIcon>
          <ListItemText>Alterar Senha</ListItemText>
        </MenuItem>
        <MenuItem
          onClick={() => {
            handleMirrorMode();
          }}
        >
          <ListItemIcon>
            <Pageview />
          </ListItemIcon>
          <ListItemText>Visualizar Como Cliente</ListItemText>
        </MenuItem>
        <MenuItem
          onClick={() => {
            setOpenDeleteModal(true);
            setAnchorEl(null);
          }}
          disabled={loadingDelete}
        >
          <ListItemIcon sx={{ color: "error.main" }}>
            <Delete />
          </ListItemIcon>
          <ListItemText sx={{ color: "error.main" }}>Excluir</ListItemText>
        </MenuItem>
      </Menu>
      <InternoModalConfirmacaoSaida
        openConfirmacao={openDeleteModal}
        load={loadingDelete}
        setOpenConfirmacao={setOpenDeleteModal}
        execute={() => {
          deleteUserClient(selectedRow?.id);
        }}
        severity={"error"}
        title={"Atenção"}
        headerText={`Esta ação não pode ser desfeita. `}
        contentText={`O usuário ${selectedRow?.login} será removido do sistema. Deseja prosseguir ?`}
        confirmText={confirmDelete}
      />
      <ModalAddUserClient
        open={openModalAddUser}
        setOpenModalAddUser={setOpenModalAddUser}
        setNewUserClient={setNewUserClient}
        createUserCliente={createUserCliente}
        createButton={createButton}
        newUserCliente={newUserCliente}
        setSnackbar={setSnackbar}
        clientes={allClientes}
      />
      <ModalEditUserCliente
        openModalEditUser={openModalEditUser}
        setOpenModalEditUser={setOpenModalEditUser}
        selectedRow={selectedRow}
        setUserEdit={setUserEdit}
        userEdit={userEdit}
        setSnackbar={setSnackbar}
        snackbar={snackbar}
        setUserCliente={setUserCliente}
        userCliente={userCliente}
        allClientes={allClientes}
      />
      <ModalEditSenha
        openModalEditSenha={openModalEditSenha}
        setOpenModalEditSenha={setOpenModalEditSenha}
        selectedRow={selectedRow}
        setUserEdit={setUserEdit}
        userEdit={userEdit}
        setSnackbar={setSnackbar}
        snackbar={snackbar}
        setUserCliente={setUserCliente}
        userCliente={userCliente}
        allClientes={allClientes}
      />
      {!!snackbar && (
        <Snackbar
          open
          onClose={() => setSnackbar(null)}
          autoHideDuration={2500}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        >
          <Alert {...snackbar} onClose={() => setSnackbar(null)} />
        </Snackbar>
      )}
    </Box>
  );
}
